var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTravelers = function SvgTravelers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,9.9c2.3,0,4.1-1.8,4.1-4.1S12.3,1.8,10,1.8c-2.3,0-4.1,1.8-4.1,4.1S7.7,9.9,10,9.9z M10,3.2 c1.4,0,2.6,1.2,2.6,2.6S11.4,8.4,10,8.4c-1.4,0-2.6-1.2-2.6-2.6S8.6,3.2,10,3.2z M17.4,15.8v1.7c0,0.4-0.3,0.8-0.8,0.8 s-0.8-0.3-0.8-0.8v-1.7c0-0.7-0.3-1.3-0.8-1.8c-0.5-0.5-1.1-0.8-1.8-0.8H6.7c-0.7,0-1.3,0.3-1.8,0.8c-0.5,0.5-0.8,1.1-0.8,1.8v1.7 c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-1.7c0-1.1,0.4-2.1,1.2-2.9c0.8-0.8,1.8-1.2,2.9-1.2h6.7c1.1,0,2.1,0.4,2.9,1.2 C17,13.7,17.4,14.7,17.4,15.8z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravelers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travelers.5bea48e8.svg";
export { ForwardRef as ReactComponent };